export enum RedZoneErrorType {
  ActiveFireError = "ActiveFireError",
  ExcessiveRiskError = "ExcessiveRiskError",
}
